import { render, staticRenderFns } from "./SubscriptionBadge.vue?vue&type=template&id=1b4205cb&"
import script from "./SubscriptionBadge.vue?vue&type=script&lang=js&"
export * from "./SubscriptionBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports